export default "__VITE_ASSET__BNJi4KXC__"